import axios, { AxiosRequestConfig } from 'axios';
import Event from './easyfy.events/easyfy.eventhandler';

namespace Easyfy.Shared.Scripts {
  export interface IExtraHeaders {
    key: string;
    value: string;
  }

  export const get = async (url: string, config?: AxiosRequestConfig): Promise<any> => {
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.get(url, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;
  };

  export const post = async (url: string, data: any, token?: string, config?: AxiosRequestConfig) => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.post(url, data, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;
  };

  export const patch = async (url: string, data: any, token?: string, config?: AxiosRequestConfig) => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.patch(url, data, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;

  };

  export const axiosDelete = async (url: string, token?: string, config?: AxiosRequestConfig) => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.delete(url, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;

  };

  function generateFullPathWithPrefix(url: string): string {
    var prefixPath = document.documentElement?.getAttribute("data-prefix-path");
    if (url && !url.startsWith("/"))
      url = "/" + url;
    if (prefixPath) {
      prefixPath = prefixPath.endsWith("/") ? prefixPath.slice(0, -1) : prefixPath;
      if (prefixPath.length > 1 && !prefixPath.startsWith("/"))
        prefixPath = "/" + prefixPath;
      if (url)
        return prefixPath + url;
      else
        return prefixPath;
    }
    else
      return url;
  }
}

export default Easyfy.Shared.Scripts;